import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageLoaderService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  hide(): void {
    const loader = this.document.getElementById('page-loader');

    if (!loader) {
      return;
    }

    loader.remove();
  }
}
